<template>
  <div>
    <div class="food_div">
      <!-- <van-icon name="bars" /> -->
      <img
        class="food_list"
        v-if="routeFalg"
        src="@/assets/img/采购食材.png"
        alt=""
      />
      <img
        class="food_list"
        v-else
        src="@/assets/img/食物.png"
        alt=""
      />
      <span style="margin-left: 8px" class="text_333">食材清单</span>
    </div>
    <recomMenuDetail :info="info" v-if="routeFalg"></recomMenuDetail>
    <van-row>
      <div class="list" v-if="routeFalg">
        <div style="overflow: hidden;padding: 10px 16px;">
          <img
            class="food_list"
            src="@/assets/img/购物车.png"
            alt=""
          />
          <span style="margin-left: 8px">食材选购</span>
          <div class="mgTop20">
            <p>快速选购</p>
            <div
              class="mgTop20 chose_fast"
            >
            <div style="padding:12px 6px 0px 6px;">
            <div style="overflow-x: auto;">
              <ul  v-if="info.tradeCookbookDtlDTOS.length" :style="ulStyle()">
                <li
                  :class="{ cell_cover: item.salePrice == null, cook_li: true }"
                  v-for="item in info.tradeCookbookDtlDTOS"
                  :key="item.skuId"
                >
                 <div class='cover_img' style='float: none;'> 
                  <img :src="item.picUrl ? item.picUrl : '@/assets/头像图片.png'" class="cook_img" alt /> 
                 </div>
                  <div class="fSize_12">
                    <span class="goods_over">
                      {{ item.goodsName + "(" + item.skuName + ")" }}
                    </span>
                    <span style="margin-top: 5px">
                      {{
                        item.saleUnitLabel
                          | filterUnit(item.saleRatio, item.goodsUnitLabel)
                      }}
                    </span>
                    <div style="margin-top: 5px">
                      <span class="text_yellow" v-if="item.salePrice == null"
                        >商品失效</span
                      >
                      <span class="ty-left text_yellow" v-else
                        >¥{{ item.salePrice }}</span
                      >
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else>
                 <van-image
                        fit="contain"
                        :src="require('@/assets/头像图片.png') "
                      />
              </div>
            </div>
            </div>
              <div class="add_car_box">
                <div>
                  <span class="text_ccc">预计</span>
                  <span class="text_yellow fSize_14">
                    ￥{{ info.unitPrice ? info.unitPrice : 0 | filterNumTwo }}/<span class="fSize_10"
                      >份</span
                    ></span
                  >
                </div>
                <div  @click="show = true" class="addCar fSize_14">一键加车</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-row>
    <van-row>
      <div class="list">
        <div >
          <div>
            <!-- <img
              v-if="routeFalg"
              class="food_list main_list"
              src="@/assets/img/调料.png"
              alt=""
              srcset=""
            /> -->
            <span style="margin-left: 8px">主料商品</span>
          </div>
          <div >
            <div style="width: 100%; overflow-x: auto">
              <ul v-if="info.tradeCookbookDtlDTOS.length">
                <li
                  :class="{
                    cell_cover: item.salePrice == null,
                    cook_li_mian: true,
                  }"
                  v-for="item in info.tradeCookbookDtlDTOS.filter(
                    (el) => el.classifyValue == 0
                  )"
                  :key="item.skuId"
                >
                <div  @click='goodsDetails(item)' class='cover_img'>
                  <img :src="item.picUrl ? item.picUrl : '@/assets/头像图片.png'" alt />
                </div>
                <div class="detail_li"  @click='goodsDetails(item)'>
                    <div class="goods_over fSize_14 text_ccc">
                      {{ item.goodsName + "(" + item.skuName + ")" }}
                    </div>
                    <div  >
                      <div class="text_yellow" v-if="item.salePrice == null">商品失效</div>
                      <div class="detail_div"   v-else>
                        <div v-if="routeFalg"   class="text_999 fSize_12"> {{item.parameter}}{{ item.goodsUnitLabel }}/份</div>
                        <span class="ty-left text_yellow"  >¥{{ item.salePrice}} /
                          <span class="fSize_10">
                               {{item.saleUnitLabel | filterUnit(item.saleRatio, item.goodsUnitLabel)}}
                          </span>
                         </span>
                         <div  v-if="!routeFalg" style="margin-top: 25px;" class="text_999 fSize_12"> {{item.parameter}}{{ item.goodsUnitLabel }}/份</div>
                      </div>
                    </div>
                  </div>
                  <span  v-if="routeFalg" class="float_right step_fixed_new"  >
                          <van-icon size="22px" color="#74B42B"  name="add" @click='addOneCart(item)'  v-if='item.orderQty == 0' />
                          <van-stepper
                            v-if='item.orderQty > 0' 
                            :min="0"
                            class="stepper"
                            button-size="22px"
                            input-width="35px"
                            integer
                            @plus='addCart(item)'
                            @minus='addCart(item,"minus")'
                            async-change
                            @change="addCart(item)"
                            v-model="item.orderQty"
                            :disable-minus="
                            item.orderQty <= 0 ? true : false
                            "
                          />
                  </span>
                </li>
              </ul>
              <div  v-else>
              <van-image
              fit="cover"
              :src="require('@/assets/默认图片.png')"
            />
              </div>
            </div>
          </div>
        </div>
        <div >
          <div>
            <!-- <img
              v-if="routeFalg"
              class="food_list main_list"
              src="@/assets/img/调料.png"
              alt=""
              srcset=""
            /> -->
            <span style="margin-left: 8px">辅料商品</span>
          </div>
          <div class="">
            <div style="width: 100%; overflow-x: auto" >
              <ul>
                <li
                 
                  :class="{
                    cell_cover: item.salePrice == null,
                    cook_li_mian: true,
                  }"
                  v-for="item in info.tradeCookbookDtlDTOS.filter(
                    (el) => el.classifyValue == 1
                  )"
                  :key="item.skuId"
                >
                <div  @click='goodsDetails(item)' class='cover_img'>
                  <img :src="item.picUrl ? item.picUrl : '@/assets/头像图片.png'" alt />
                </div>
                  <div  class="detail_li">
                    <div class="goods_over fSize_14 text_ccc">
                      {{ item.goodsName + "(" + item.skuName + ")" }}
                    </div>
                      <div >
                        <div  class="text_yellow" v-if="item.salePrice == null">商品失效</div>
                        <div class="detail_div"  v-else>
                         <div  class="text_999 fSize_12" v-if="routeFalg">
                           {{item.parameter}}{{ item.goodsUnitLabel }}/份 
                            </div>
                        <span class="ty-left text_yellow"  >¥{{ item.salePrice}} /
                        <span class="fSize_10">
                             {{item.saleUnitLabel | filterUnit(item.saleRatio, item.goodsUnitLabel)}}
                        </span>
                       </span>
                       <div  v-if="!routeFalg" style="margin-top: 25px;" class="text_999 fSize_12"> {{item.parameter}}{{ item.goodsUnitLabel }}/份</div>
                      </div>
                    </div>
                  </div>
                  <span v-if="routeFalg" class="float_right step_fixed_new"  >
                          <van-icon size="22px" color="#74B42B" name="add" @click='addOneCart(item)'  v-if='item.orderQty == 0' />
                          <van-stepper
                            v-if='item.orderQty > 0' 
                            :min="0"
                            class="stepper"
                            button-size="22px"
                            input-width="35px"
                            integer
                            @plus='addCart(item)'
                            @minus='addCart(item,"minus")'
                            async-change
                            @change="addCart(item)"
                            v-model="item.orderQty"
                            :disable-minus="
                            item.orderQty <= 0 ? true : false
                            "
                          />
                    </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </van-row>
   <van-popup  lock-scroll :close-on-click-overlay='false'  round position="bottom"  :style="{height: '80%',overflow:'hidden'}"  v-model="show">
    <commonCar v-if="show" @close='show = false'></commonCar>
   </van-popup>
  </div>
</template>
<script>
import recomMenuDetail from "./recomMenuDetail";
import commonCar from "./commonCar";
export default {
  components: { recomMenuDetail, commonCar },
  props: {
    info: {
      default: {
        tradeCookbookDtlDTOS: []
      }
    }
  },
  created() {
    this.routeFalg = this.$route.query.remark == "recom" ? true : false;
    this.customerId = +localStorage.getItem("customerId");
  },
  data() {
    return {
      routeFalg: false,
      customerId: "",
      show: false
    };
  },

  methods: {
    ulStyle() {
      let width = this.info.tradeCookbookDtlDTOS.length;
      return {
        width: `${101 * width}px`,
        marginBottom: "20px"
      };
    },
    changgeGoods(){
      this.$toast("商品数量必须大于0并且小于四位数的整数");
      event.stopPropagation()
      event.preventDefault()
    },
     goodsDetails(item){
      if(item.salePrice == null) return;
         this.$router.push({
            path: "/details",
            query: { goodsId: item.goodsId, got: "true" }
          });
    },
    addOneCart(item){
      item.orderQty = 1;
      this.addCart(item)
    },
    addCart(item, mark = "plus") {
      event.stopPropagation();  
      if (String(item.orderQty).length > 3) {
        this.$toast("商品数量必须大于0并且小于四位数的整数");
        return;
      }
      item.customerId = this.customerId;
      this.$axios.post("trade/tradeCart/save", item).then(res => {
        if (res.data) {
          if (mark == "minus") return;
          this.$toast("已修改购物车数量");
        }
      });
    }
  }
};
</script>

<style lang='scss' scoped>
.addBtn.van-button--large {
  height: 40px;
  border: 1px dashed rgb(116, 180, 43);
  color: rgb(116, 180, 43);
}
.addBtn.van-hairline--surround::after {
  border: none;
}

/deep/ .van-field__control {
  width: 17%;
}
img {
  float: left;
  width: 80px;
  height: 88px;
  background: rgba(247, 247, 247, 1);
  border-radius: 2px;
}
.list {
  background-color: #fff;
  ul{
    padding: 10px 16px;
    margin-top: 10px
  }
  // padding: 10px 16px;
}
/deep/ .van-col {
  font-size: 14px;
}
.cook_li {
  width: 88px;
  display: inline-block;
  margin-right: 13px;
  background-image: url(../imgs/矩形备份3.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: 0px;
  font-size: 12px;
}
.cook_img {
  float: none;
}
.food_list {
  all: unset;
  vertical-align: middle;
  background: #fff;
  &.main_list {
    margin-right: 4px;
  }
}
.food_div {
  margin-top: 10px;
  background-color: #fff;
  padding: 10px 16px;
  box-sizing: border-box;
}
.chose_fast {
  // background-image: url(../imgs/矩形备份.png);
  // background-repeat: no-repeat;
  // background-size: 100% 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 4px 1px rgba(153, 153, 153, 0.1);
  border-radius: 10px;
  width: 100%;
  box-sizing: border-box;
  .add_car_box {
    padding: 10px 0;
    border-top: 1px solid rgba(221,221,221,0.5);
    line-height: 32px;
    display: flex;
    justify-content: flex-end;
  }
  .addCar {
    background-image: url(../imgs/矩形1.png);
    background-size: 100%;
    width: 104px;
    text-align: center;
    height: 32px;
    color: #fff;
    background-repeat: no-repeat;
    margin-left: 12px;
  }
}
/deep/ .van-stepper {
  display: inline-block;
}
.stepper {
  /deep/ button {
    background-color: transparent;
  }
  /deep/ input {
    background-color: transparent;
  }
}
.step_fixed_new{
  position: absolute;
  bottom: 5px;
  right:6px;
  /deep/ .van-icon{
          bottom: -6px;
        }
}
</style>